import { render } from "./MindMap.vue?vue&type=template&id=1ec7f580&scoped=true"
import script from "./MindMap.vue?vue&type=script&lang=js"
export * from "./MindMap.vue?vue&type=script&lang=js"

import "./MindMap.vue?vue&type=style&index=0&id=1ec7f580&lang=less"
import "./MindMap.vue?vue&type=style&index=1&id=1ec7f580&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec7f580"]])

export default __exports__